/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { Float, useGLTF } from '@react-three/drei'
import { animated } from "@react-spring/three";

export function Balon3Model(props) {
  const { nodes, materials } = useGLTF('/data/baloon3.glb')
  return (
    <Float
      speed={3} // Animation speed, defaults to 1
      rotationIntensity={1} // XYZ rotation intensity, defaults to 1
      floatIntensity={1} // Up/down float intensity, works like a multiplier with floatingRange,defaults to 1
      floatingRange={[-0.1, 0.1]} >
      <animated.group {...props} dispose={null} position={props.bPosition}  rotation={props.bRotation}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.BalonTriangle_3.geometry}
          position={[0.198, 0, 0.309]}
          scale={[0.3, 0.3, 0.3]}
        >
          <animated.meshPhysicalMaterial color={props.color}
            shininess={1}
            specularColor={[
              2.0000000474157864,
              2.0000000474157864,
              2.0000000474157864
            ]}
            specularIntensity={1}
            metalness={1}
            roughness={0.22}/>
        </mesh>
      </animated.group>
    </Float>
  )
}

// useGLTF.preload('/data/baloon3.glb')
